import DashboardFullScreen from "./dashboardFullScreen";
export default DashboardFullScreen;